module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }